import React from 'react';
import PropTypes from 'prop-types';

const Loader = ({loading}) => (
	loading ? <div className="loading" /> : null
);

Loader.propTypes = {
	loading: PropTypes.bool
};
export default Loader;



// WEBPACK FOOTER //
// ./src/components/common/Loader.js